import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no 8-hour drive to Denver needed",
      "Ideal for BIL international flyers",
      "Perfect for energy sector workers on overseas rotations",
      "Great for MSU Billings & Rocky Mountain College study-abroad students",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Billings post offices",
      "Good for planned international trips from BIL",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection and restart the clock",
      "In-person clerk appointment required at Yellowstone County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Denver — ~550 miles, 8+ hour drive via I-25",
      "NPIC appointment required before driving to Denver",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Montana has zero passport agencies — Denver is the closest in any direction",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Billings"
      headingExtra="MT"
      introText="Billings and Montana travelers — BIL international flyers, energy sector workers on overseas rotations, MSU Billings and Rocky Mountain College study-abroad students, Yellowstone region tourism professionals, regional healthcare workers on medical missions, and Big Sky country ranchers heading to international agribusiness conferences — have several options for getting a passport fast. Here is how they compare, and why most Montanans choose a U.S. Department of State registered passport courier rather than making the 450-mile drive to the Denver Passport Agency."
      options={options}
      emergencyDescription="Montana has zero regional passport agencies. The closest agency is in Denver, Colorado — roughly 450 miles south via I-25, a 6+ hour drive each way. You must obtain an NPIC appointment before traveling, and walk-ins are not accepted at the Denver Passport Agency."
      disclaimerText="*Processing speed depends on eligibility and documentation. Montana has no regional passport agency — the closest is Denver, Colorado, roughly 550 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}